module.exports = __webpack_public_path__ + "static/img/TJQ.f9dae9dd.png";